// Vendor-side mapping page — Tricivo customer → QB vendor.

import { QuickBooksMappingPage } from './QuickBooksMappingPage';

export function QuickBooksVendorMappingPage(): JSX.Element {
  return (
    <QuickBooksMappingPage
      kind="vendor"
      title="QuickBooks vendor mappings"
      subtitle="Map Tricivo customers to QuickBooks vendors."
      fieldLabel="Customer name"
    />
  );
}
